import { motion } from "framer-motion";
import { CaseHeader } from "../CaseHeader";

interface CaseHeaderSectionProps {
  onCreateCase: () => void;
  onRefresh: () => Promise<void>;
}

export function CaseHeaderSection({ onCreateCase, onRefresh }: CaseHeaderSectionProps) {
  return (
    <motion.div 
      initial={{ y: -20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      className="flex-none bg-gradient-to-r from-amber-50 to-white dark:from-amber-950/20 dark:to-background p-4 md:p-6 rounded-lg border shadow-sm"
    >
      <CaseHeader
        onCreateCase={onCreateCase}
        onRefresh={onRefresh}
      />
    </motion.div>
  );
}